import type { AutomationCategoryResponse } from '@reach/shared-types/automation-category';
import type { CSSProperties } from 'react';
import styles from './CategoryPill.module.css';

interface CategoryPillProps {
  category: Pick<AutomationCategoryResponse, 'name' | 'color'>;
}

/** A category's name in its color. Used in the templates list, filters, and the category picker. */
export function CategoryPill({ category }: CategoryPillProps) {
  const colorStyle = { '--category-color': category.color } as CSSProperties;
  return (
    <span className={styles.categoryPill} style={colorStyle}>
      {category.name}
    </span>
  );
}
